import i18n from '../i18n';

const NOTE_PARAM_KEYS = {
  collab_invite: 'inviterName',
  collab_accepted: 'responderName',
  collab_rejected: 'responderName',
  ownership_transferred: 'oldOwnerName',
};

const parseData = (data) => {
  if (!data) return {};
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (e) {
      return {};
    }
  }
  return data;
};

// Renders a { type, data } notification into a localized { title, message } pair.
// Falls back to the raw stored title/message for unrecognized types or legacy rows.
export function renderNotification(notification) {
  const type = notification?.type;
  const data = parseData(notification?.data);

  if (type === 'password_changed') {
    return {
      title: i18n.t('notifications:password_changed.title'),
      message: i18n.t('notifications:password_changed.message'),
    };
  }

  if (NOTE_PARAM_KEYS[type]) {
    const name = data[NOTE_PARAM_KEYS[type]] || i18n.t('notifications:fallbackName');
    const noteTitle = data.noteTitle || i18n.t('notifications:fallbackNote');
    return {
      title: i18n.t(`notifications:${type}.title`),
      message: i18n.t(`notifications:${type}.message`, { name, noteTitle }),
    };
  }

  if (type === 'collab_removed' || type === 'collab_frozen') {
    const noteTitle = data.noteTitle || i18n.t('notifications:fallbackNote');
    return {
      title: i18n.t(`notifications:${type}.title`),
      message: i18n.t(`notifications:${type}.message`, { noteTitle }),
    };
  }

  if (type === 'friend_request') {
    const name = data.sender_email || i18n.t('notifications:fallbackName');
    return {
      title: i18n.t('notifications:friend_request.title'),
      message: i18n.t('notifications:friend_request.message', { name }),
    };
  }

  if (type === 'friend_accepted') {
    const name = data.friend_email || i18n.t('notifications:fallbackName');
    return {
      title: i18n.t('notifications:friend_accepted.title'),
      message: i18n.t('notifications:friend_accepted.message', { name }),
    };
  }

  if (type === 'group_added' || type === 'group_removed') {
    const name = data.groupName || i18n.t('notifications:fallbackGroup');
    return {
      title: i18n.t(`notifications:${type}.title`),
      message: i18n.t(`notifications:${type}.message`, { name }),
    };
  }

  return {
    title: notification?.title || '',
    message: notification?.message || '',
  };
}

export default renderNotification;
